<template>
  <v-card class="d-flex flex-column flex-grow-1">
    <v-card-text class="px-4 d-flex flex-column">
      <v-card-title class="pt-0 px-0">
        <span class="table-card-title-whats pl-0">Visualização da mensagem</span>
      </v-card-title>
      <v-container class="smartphone-block pt-0 px-0" fill-height>
        <v-row class="title-row" align="center">
          <mf-icon class="ml-3">arrow_back_ios</mf-icon>
          <mf-icon large>lens</mf-icon>
          <div class="ml-2">
            <div class="first-line" />
            <div class="second-line" />
          </div>
          <v-spacer />
          <mf-icon large>stop</mf-icon>
          <mf-icon class="mr-3" large>stop</mf-icon>
          <mf-icon class="mr-3" large>more_vert</mf-icon>
        </v-row>
        <v-row class="content-row" justify="end" fill-height>
          <v-col class="bubble-block" align-self="end" fill-height>
            <div v-if="(message && message.text) || thumbnailUrl" class="message">
              <div v-if="thumbnailUrl" class="image-container">
                <v-img max-height="200px" width="100%" eager position="center center" :src="thumbnailUrl"> </v-img>
                <div class="d-flex justify-end mt-1">
                  <download-file-button :url="fileUrl" :label="downloadFileButtonLabel" />
                </div>
              </div>
              <span v-for="(msg, index) of splittedText" :key="index" v-html-safe="getWhatsappRevisedText(msg)" />
              <div v-if="hasOptoutMessage && optoutMessage.active">
                <br />
                <span>{{ optoutMessage.interpolated_text }}</span>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import gql from 'graphql-tag'
import { textVariables } from '@/mixins/text-variables'
import DownloadFileButton from '@/components/DownloadFileButton.vue'
const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType {
    getMessageByType(type: OPTOUT_SUFFIX) {
      interpolated_text
      active
    }
  }
`

export default {
  components: { DownloadFileButton },
  mixins: [textVariables],
  props: {
    message: Object,
    thumbnailUrl: String,
    fileUrl: String,
    fileName: String,
    fileMimetype: String,
    messageVariablesDisabled: {
      type: Boolean,
      default: false,
    },
    hasOptoutMessage: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    optoutMessage: {},
  }),
  computed: {
    downloadFileButtonLabel() {
      if (this.fileMimetype === 'application/pdf') {
        return 'Baixar documento'
      }
      return 'Baixar imagem'
    },
    splittedText() {
      if (!this.message.text) return []
      return this.message.text.split('\n')
    },
  },
  apollo: {
    optoutMessage: {
      query: QUERY_GET_MESSAGE_BY_TYPE,
      update({ getMessageByType }) {
        return getMessageByType
      },
    },
  },
  methods: {
    getWhatsappRevisedText(text) {
      return `${this.getRevisedText(text)}<br />`
    },
  },
}
</script>

<style lang="scss">
.table-card-title-whats {
  font-size: 18px;
  color: $cinza-d10;
  @extend .card-title;
}

.smartphone-block {
  margin-right: -12px;
  .message-preview-title {
    margin-left: -12px;
    padding-bottom: 30px;
  }
  .title-row {
    background-color: #d6e3fe;
    height: 60px;
    .first-line {
      width: 85px;
      height: 10px;
      background-color: #b3cafe;
      border-radius: 2px;
    }
    .second-line {
      width: 150px;
      height: 8px;
      background-color: #b3cafe;
      margin-top: 4px;
      border-radius: 2px;
    }
    i {
      color: #b3cafe;
    }
  }
  .content-row {
    height: 650px;
    overflow: auto;
    background-color: #ecf2fe;
    .bubble-block {
      max-width: 85%;
      .message {
        border-radius: 4px;
        background-color: #b5caf7 !important;
        padding: 8px;
        color: $marca-0-l10 !important;
        .image-container {
          position: relative;
          display: block; /* Or 'block' depending on your layout needs */
        }

        .download-link {
          position: absolute;
          bottom: 0;
          right: 0;
          background-color: rgba(255, 255, 255, 0.7); /* Optional: for better visibility */
          padding: 5px; /* Adjust as needed */
          text-decoration: none; /* Optional: for styling the link */
        }
      }
    }
  }
}

.variable-highlight {
  color: $marca-1;
}

.variable-error {
  color: #d83e3e !important;
}

.variable-error-super {
  .variable-highlight {
    color: $marca-1 !important;
  }
  color: #d83e3e !important;
}
</style>
